import { createReducer, on } from '@ngrx/store';
import { viewToast, hideToast } from './common.actions';

export interface State {
  view: boolean;
  message: String;
}

export const initialState: State = {
  view: false,
  message: '',
};

export const commonReducer = createReducer(
  initialState,

  on(viewToast, (state, { message }) => ({ view: true, message })),
  on(hideToast, (state) => ({ ...state, view: false }))
);
